import { motion } from "framer-motion";
import { Eye, ShieldCheck, Zap, Lightbulb, Target } from "lucide-react";

const values = [
  { icon: Eye, title: "Transparência", description: "Clareza em todas as etapas do processo" },
  { icon: ShieldCheck, title: "Credibilidade", description: "Mais de 30 anos de confiança no mercado" },
  { icon: Zap, title: "Agilidade", description: "Respostas rápidas para demandas complexas" },
  { icon: Lightbulb, title: "Inovação", description: "Soluções criativas para desafios únicos" },
  { icon: Target, title: "Resultados", description: "Foco absoluto em performance mensurável" },
];

export const ValuesSection = () => {
  return (
    <section id="valores" data-testid="values-section" className="py-20 md:py-32 bg-brand-navy relative overflow-hidden">
      <div className="absolute inset-0 opacity-10" style={{ backgroundImage: `radial-gradient(circle at 90% 80%, #2bb5b2 0%, transparent 40%)` }} />
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="text-center mb-16">
          <span className="text-sm font-bold uppercase tracking-[0.2em] text-brand-teal mb-4 block">Nosso DNA</span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white mb-4" data-testid="values-title">Nossos Valores</h2>
          <p className="text-base lg:text-lg text-slate-300 max-w-2xl mx-auto">Os princípios que norteiam cada decisão e entrega da Duali Soluções</p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-6">
          {values.map((value, i) => (
            <motion.div key={value.title} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: 0.1 * i }}
              data-testid={`value-card-${i}`} className="group text-center p-6 rounded-2xl bg-white/5 border border-white/10 hover:bg-white/10 hover:border-brand-teal/30 transition-all duration-500">
              <div className="w-14 h-14 mx-auto bg-brand-teal/20 rounded-xl flex items-center justify-center mb-4 group-hover:bg-brand-teal/30 transition-colors duration-300">
                <value.icon className="text-brand-teal" size={26} />
              </div>
              <h3 className="text-base font-bold text-white mb-2">{value.title}</h3>
              <p className="text-xs text-slate-400 leading-relaxed">{value.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
